import React from 'react'

const Reports = () => {
  return (
    <div className='h-[88vh] overflow-y-scroll p-10'>Reports</div>
  )
}

export default Reports